export default __webpack_public_path__ + "static/media/soulbrain_logo_white.e74998a6.png";